import { render } from "./CartButton.vue?vue&type=template&id=52395070&scoped=true"
import script from "./CartButton.vue?vue&type=script&lang=ts"
export * from "./CartButton.vue?vue&type=script&lang=ts"

import "./CartButton.vue?vue&type=style&index=0&id=52395070&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-52395070"

export default script